import { forwardRef } from "react";
import type { IconProps } from "../shared";
import { Icon } from "../icon";
export const IconArrowLeft = forwardRef<HTMLElement, IconProps>(
    (props, ref) => (
        <Icon ref={ref} {...props}>
            <path
                fill="#111928"
                fillRule="evenodd"
                d="m11 19-7-7 7-7 1.42 1.42L7.83 11H20v2H7.83l4.58 4.59z"
                clipRule="evenodd"
            />
        </Icon>
    )
);
IconArrowLeft.displayName = "IconArrowLeft";
